module.exports = __webpack_public_path__ + "static/ApocalipsisZombie-6a5d3447fbbefe983da1c64d4e9dbdc3.jpg";